export enum ProductEnums {
  OneMedicalTakafulEn = 'OneMedicalTakaful-en',
  OneMedicalTakafulMy = 'OneMedicalTakaful-my',
  OneMedicalInsuranceEn = 'OneMedicalInsurance-en',
  OneMedicalInsuranceMy = 'OneMedicalInsurance-my',
  OneMedicalTakafulEnMobile = 'OneMedicalTakaful-en-Mobile',
  OneMedicalTakafulMyMobile = 'OneMedicalTakaful-my-Mobile',
  OneMedicalInsuranceEnMobile = 'OneMedicalInsurance-en-Mobile',
  OneMedicalInsuranceMyMobile = 'OneMedicalInsurance-my-Mobile',
  EasyMedicEn = 'EasyMedic-en',
}
